import type { SFState } from '../api/adminTypes'

// One badge for every status the console shows: application status
// (in_progress/submitted/abandoned) and Salesforce push state
// (success/partial/failed/retrying/queued/null). Both are small closed sets
// of strings, so one component keyed by string is simpler than two near-
// duplicate ones.
const TONES: Record<string, { bg: string; text: string; border: string }> = {
  success: {
    bg: 'var(--color-success-surface)',
    text: 'var(--color-success-text)',
    border: 'var(--color-success-border)',
  },
  submitted: {
    bg: 'var(--color-success-surface)',
    text: 'var(--color-success-text)',
    border: 'var(--color-success-border)',
  },
  partial: {
    bg: 'var(--color-warning-surface)',
    text: 'var(--color-warning-text)',
    border: 'var(--color-warning-border)',
  },
  retrying: {
    bg: 'var(--color-warning-surface)',
    text: 'var(--color-warning-text)',
    border: 'var(--color-warning-border)',
  },
  failed: {
    bg: 'var(--color-error-surface)',
    text: 'var(--color-error-text)',
    border: 'var(--color-error-border)',
  },
  abandoned: {
    bg: 'var(--color-error-surface)',
    text: 'var(--color-error-text)',
    border: 'var(--color-error-border)',
  },
}

const DEFAULT_TONE = {
  bg: 'var(--color-surface-container-low)',
  text: 'var(--color-text-secondary)',
  border: 'var(--color-outline-variant)',
}

export function StatusBadge({ status }: { status: string | SFState | null | undefined }) {
  const label = status ?? 'none'
  const tone = (status && TONES[status]) || DEFAULT_TONE
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: tone.bg,
        border: `1px solid ${tone.border}`,
        borderRadius: 'var(--radius-full)',
        padding: '2px 10px',
        fontFamily: 'var(--font-body)',
        fontSize: 'var(--text-label-sm)',
        fontWeight: 'var(--weight-semibold)',
        color: tone.text,
        whiteSpace: 'nowrap',
        textTransform: 'capitalize',
      }}
    >
      {label.replace('_', ' ')}
    </span>
  )
}
